import { AuditSystem } from './audit-system';
import { AuditProvider } from './audit-context';
import { AuditProvider as AuditTaskProvider } from '../InternalAudit/audit-context';

function InternalAuditDetail() {
  return (
    <AuditTaskProvider>
      <AuditProvider>
        <AuditSystem />
      </AuditProvider>
    </AuditTaskProvider>
  );
}

export default InternalAuditDetail;
